import { AccessToken } from "../../../interface/AccessToken";

const ACCESS_TOKEN_KEY = "fpsb.portal.access.token";

class AuthClientStore {
    static getAccessToken(): AccessToken | null {
        const token = localStorage.getItem(ACCESS_TOKEN_KEY)
        return token ? JSON.parse(token) : null;
    }

    static setAccessToken(token: AccessToken) {
        localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(token));
    }

    static removeAccessToken(): void {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
    }
}

export default AuthClientStore;
